import styled from 'styled-components';

const MainNav = styled.nav`
  grid-area: mainNav;
  min-width: 100%;
  max-width: 100%;
`;

const MainHeader = styled.header`
  display: flex;
  flex-direction: column;
  gap: 4px;
  grid-area: mainHeader;
  width: 100%;
  min-height: 102px;
  
  @media (min-width: 600px) {
    margin-bottom: 12px;
  }
`;

const MainHeaderTitle = styled.h1`
  font-size: ${(props) => props.theme.typography.size.md4}px;
  line-height: ${(props) => props.theme.typography.lineHeight.lg2}px;
  font-weight: 900;
`;

const MainTabs = styled.div`
  grid-area: mainTabs;
`;

type GalleryProps = {
  disabled?: boolean;
};
const Gallery = styled.article<GalleryProps>`
  grid-area: gallery;
  margin-bottom: 16px;
  margin-top: 0px;
  width: 100%;
  max-width: 1200px;
  max-height: 768px;
  min-height: 224px;

  @media (min-width: 600px) {
    min-height: fit-content;
  }
  ${(props) => props.disabled &&  `
    pointer-events: none;
    opacity: 0.5;
  `}
`;

const MainTags = styled.div`
  grid-area: mainTags;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 0.5rem;
  min-height: 152px;
`;

const HeaderTags = styled.h3``;

const AsideRight = styled.aside`
  grid-area: asideRight;
  height: 100%;
  padding-top: 16px;
  padding-right: 16px;
`;

const MainContent = styled.main`
  grid-area: mainContent;
  gap: 30px;
  display: flex;
  flex-direction: column;
  gap: 56px;
`;

const MapSection = styled.div`
  grid-area: mapSection;
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;

  h3 {
    line-height: 36px;
  }
`;

const PriceSection = styled.div`
  grid-area: priceSection;
  margin-top: 8px;
  width: 100%;
`;

const RecommendationsSection = styled.div`
  grid-area: recommendationsSection;
  display: flex;
  gap: 24px;
  width: fit-content;
  position: relative;
  width: 100%;
`;

const Faqs = styled.div`
  grid-area: faqs;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 8px;
  width: 100%;
`;

const RecommendedLink = styled.a`
  width: 100%;
`;

const GridLayout = styled.div`
  /* height: 100%; */
  display: grid;
  justify-items: start;
  align-items: center;
  max-width: 774px !important;
  margin: auto;
  transition: all 0.3s ease;
  grid-template-areas:
    'mainNav'
    'gallery'
    'mainTabs'
    'mainHeader'
    'mainTags'
    'mainContent'
    'asideRight'
    'mapSection'
    'priceSection'
    'faqs'
    'recommendationsSection';
  ${MainTabs} {
    padding: 0 16px;
  }
  ${MainHeader},
  ${MainContent},
  ${MainTags},
  ${MainContent},
  ${MapSection},
  ${PriceSection},
  ${RecommendationsSection},
  ${Faqs} {
    padding: 16px;
    position: relative;
  }

  h3 {
    font-size: 18px;
    font-family: 'Satoshi', 'Helvetica Neue', Helvetica, Arial, 'sans-serif';
    font-weight: 900;
  }

  @media (min-width: 500px) {
    grid-template-columns: 3fr 1fr;
    grid-template-areas:
      'mainNav                mainNav'
      'mainHeader             mainTabs'
      'gallery                gallery'
      'mainTags               mainTags'
      'mainContent            asideRight'
      'mapSection             mapSection'
      'priceSection           priceSection'
      'recommendationsSection recommendationsSection'
      'faqs                   faqs';

    ${MainHeader}
    ${MainContent},
    ${MainTags},
    ${MainContent},
    ${MapSection},
    ${PriceSection},
    ${RecommendationsSection},
    ${Faqs} {
      padding: 16px;
    }
    ${Gallery} {
      padding: 0 16px;
    }
    ${AsideRight} {
      padding-left: 0;
    }
    ${MainTabs} {
      display: flex;
      justify-content: flex-end;
      width: 100%;
      align-items: flex-end;
      height: 100%;
      padding: 16px 16px 30px 16px;
    }
    ${MainHeader} {
      padding-bottom: 12px;
      padding-top: 48px;
      justify-content: flex-end;
    }
    ${MainContent} {
      padding-right: 70px !important;
    }

    ${MainTags} {
      min-height: 104px;
    }

    h3 {
      font-size: 24px;
      font-family: 'Satoshi', 'Helvetica Neue', Helvetica, Arial, 'sans-serif';
    }
  }

  @media (min-width: 1200px) {
    max-width: 794px !important;
  }
  @media (min-width: 1800px) {
    max-width: 1120px !important;
  }

  :before {
    background-color: #e5e5e5;
  }
`;

export const MainGridLayout = styled.div``;
export {
  GridLayout,
  MainNav,
  MainHeader,
  MainHeaderTitle,
  MainTabs,
  Gallery,
  MainTags,
  HeaderTags,
  AsideRight,
  MainContent,
  MapSection,
  PriceSection,
  RecommendationsSection,
  Faqs,
  RecommendedLink,
};
